import { CDN_ASSET, CDN_ASSET_ROOT, CDN_IMG } from "../../utils/common";

export const icAsset = (input?: string): string => {
  if (window.location.hostname === "localhost") {
    return input ?? ("" as string);
  }
  if (!input) return "" as string;
  if (!CDN_ASSET) return input;
  return input.replace(
    /^(\.\.\/)+assets\//,
    CDN_ASSET + CDN_ASSET_ROOT + "/assets/",
  );
};
export const cdnImg = (input: string): string => {
  if (!input) return "" as string;
  if (!CDN_IMG) return input;
  return input.replace(
    /^(\.\.\/)+assets\//,
    CDN_IMG + CDN_ASSET_ROOT + "/assets/",
  );
};
export const icMinus = icAsset("../../../assets/icons/ic-minus.svg");
export const icPlus = icAsset("../../../assets/icons/ic-plus.svg");
export const icClock = icAsset("../../../assets/icons/ic-clock.svg");
export const icArrowDown = icAsset("../../../assets/icons/ic-arrow-down.svg");
export const icArrowDown2 = icAsset("../../../assets/icons/arrow-down.svg");
export const icNextBlue = icAsset("../../../assets/icons/ic-next-blue.svg");
export const icWarnRed = icAsset("../../../assets/icons/ic-warn-red.svg");

export const icUserOutline = icAsset(
  "../../../assets/icons/ic-user-outline.svg",
);
export const icLangOutline = icAsset(
  "../../../assets/icons/ic-lang-outline.svg",
);
export const icCartOutline = icAsset(
  "../../../assets/images/icons/shopping-card-outline.svg",
);
export const icQuestion = icAsset("../../../assets/icons/question.svg");
export const icCheck = icAsset("../../../assets/icons/check.svg");
export const icWarningPopup = icAsset(
  "../../../assets/icons/warning-popup.svg",
);

export const icCartOutlineBlack = icAsset(
  "../../../assets/images/icons/shopping-card.svg",
);
export const icShareOutline = icAsset(
  "../../../assets/icons/ic-share-outline.svg",
);
export const icLoveOutline = icAsset(
  "../../../assets/icons/ic-love-outline.svg",
);
export const icLovedOutline = icAsset(
  "../../../assets/icons/ic-loved-outline.svg",
);
export const icBack = icAsset("../../../assets/icons/ic-back.svg");
export const icBackArrow = icAsset("../../../assets/icons/ic-back-arrow.svg");
export const icBackArrowBlack = icAsset(
  "../../../assets/icons/ic-back-arrow-black.svg",
);
export const icCart = icAsset("../../../assets/images/icons/shopping-card.svg");

export const icHome = icAsset("../../../assets/images/icons/ic-home.svg");
export const icHomeActive = icAsset(
  "../../../assets/images/icons/ic-home-active.svg",
);
export const icCity = icAsset("../../../assets/images/icons/ic-city.svg");
export const icCityActive = icAsset(
  "../../../assets/images/icons/ic-city-active.svg",
);
export const icPass = icAsset("../../../assets/images/icons/ic-pass.svg");
export const icPassActive = icAsset(
  "../../../assets/images/icons/ic-pass-active.svg",
);
export const icBooking = icAsset("../../../assets/images/icons/ic-booking.svg");
export const icBookingActive = icAsset(
  "../../../assets/images/icons/ic-booking-active.svg",
);
export const icMore = icAsset("../../../assets/images/icons/ic-more.svg");
export const icMoreActive = icAsset(
  "../../../assets/images/icons/ic-more-active.svg",
);

export const icClose = icAsset("../../../assets/icons/ic-close.svg");
export const icCloseRed = icAsset("../../../assets/icons/ic-close-red.svg");
export const icPremiumPlusTag = icAsset(
  "../../../assets/icons/premium-plus-tag.svg",
);
export const icDelete = icAsset("../../../assets/icons/ic-delete.svg");
export const icDelete2 = icAsset("../../../assets/icons/ic-delete2.svg");
export const icDeleteRed = icAsset("../../../assets/icons/ic-delete-red.svg");
export const icEdit = icAsset("../../../assets/icons/ic-edit.svg");
export const icEdit2 = icAsset("../../../assets/icons/ic-edit2.svg");
export const icNew = icAsset("../../../assets/icons/ic-new.svg");

export const icWarningYellow = icAsset(
  "../../../assets/icons/warning-yellow.svg",
);
export const icSwiperPrevArrow = icAsset(
  "../../../assets/icons/swiper_prev_arrow.svg",
);
export const icSwiperNextArrow = icAsset(
  "../../../assets/icons/swiper_next_arrow.svg",
);
export const icNoBooking = icAsset("../../../assets/icons/no-booking.svg");
export const icDeleteImage = icAsset("../../../assets/icons/delete-image.svg");
